module.exports = __webpack_public_path__ + "img/aham-wp-logo-white.45255c32.png";